var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 567,
    viewBox: "0 0 572 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_2336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1804 0V298.368C46.1804 327.241 62.6369 354.352 90.4072 371.222L411.17 566.103H571.999V0H46.1804Z",
    fill: "url(#paint0_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.1753 0H0L47.1753 298.368L114.026 122.865L47.1753 0Z",
    fill: "url(#paint1_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M424.363 566.103H323.659L138.902 357.858L116.346 298.368L183.195 122.862L424.363 566.103Z",
    fill: "url(#paint2_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1862 0V298.368C46.1862 327.241 62.6428 354.352 90.4088 371.222L184.296 428.264H572V0H46.1862Z",
    fill: "url(#paint3_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8 566.102H572V428.263H183.402L410.8 566.102Z",
    fill: "url(#paint4_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M530.179 503.557C538.387 503.557 545.041 502.042 545.041 500.173C545.041 498.305 538.387 496.79 530.179 496.79C521.971 496.79 515.317 498.305 515.317 500.173C515.317 502.042 521.971 503.557 530.179 503.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M456.656 522.468C462.308 522.468 466.89 521.425 466.89 520.138C466.89 518.852 462.308 517.809 456.656 517.809C451.003 517.809 446.421 518.852 446.421 520.138C446.421 521.425 451.003 522.468 456.656 522.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M373.073 507.884C375.137 507.884 376.811 507.503 376.811 507.033C376.811 506.563 375.137 506.182 373.073 506.182C371.009 506.182 369.335 506.563 369.335 507.033C369.335 507.503 371.009 507.884 373.073 507.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M498.082 523.319C500.147 523.319 501.82 522.938 501.82 522.469C501.82 521.999 500.147 521.618 498.082 521.618C496.018 521.618 494.344 521.999 494.344 522.469C494.344 522.938 496.018 523.319 498.082 523.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M556.092 525.352C563.088 525.352 568.76 524.061 568.76 522.469C568.76 520.876 563.088 519.585 556.092 519.585C549.095 519.585 543.423 520.876 543.423 522.469C543.423 524.061 549.095 525.352 556.092 525.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M396.682 531.179C401.942 531.179 406.205 530.209 406.205 529.012C406.205 527.815 401.942 526.844 396.682 526.844C391.423 526.844 387.16 527.815 387.16 529.012C387.16 530.209 391.423 531.179 396.682 531.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.553 502.763C446.837 502.763 451.931 501.603 451.931 500.173C451.931 498.743 446.837 497.583 440.553 497.583C434.269 497.583 429.175 498.743 429.175 500.173C429.175 501.603 434.269 502.763 440.553 502.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M350.675 446.029C358.883 446.029 365.537 444.515 365.537 442.646C365.537 440.778 358.883 439.263 350.675 439.263C342.467 439.263 335.813 440.778 335.813 442.646C335.813 444.515 342.467 446.029 350.675 446.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M424.199 464.941C429.851 464.941 434.434 463.898 434.434 462.612C434.434 461.325 429.851 460.282 424.199 460.282C418.547 460.282 413.965 461.325 413.965 462.612C413.965 463.898 418.547 464.941 424.199 464.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M507.782 450.357C509.846 450.357 511.52 449.976 511.52 449.506C511.52 449.036 509.846 448.655 507.782 448.655C505.718 448.655 504.044 449.036 504.044 449.506C504.044 449.976 505.718 450.357 507.782 450.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M382.772 465.792C384.837 465.792 386.51 465.412 386.51 464.942C386.51 464.472 384.837 464.091 382.772 464.091C380.708 464.091 379.035 464.472 379.035 464.942C379.035 465.412 380.708 465.792 382.772 465.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.763 467.825C331.759 467.825 337.431 466.534 337.431 464.942C337.431 463.349 331.759 462.058 324.763 462.058C317.766 462.058 312.095 463.349 312.095 464.942C312.095 466.534 317.766 467.825 324.763 467.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M484.173 473.652C489.432 473.652 493.696 472.682 493.696 471.485C493.696 470.288 489.432 469.317 484.173 469.317C478.914 469.317 474.65 470.288 474.65 471.485C474.65 472.682 478.914 473.652 484.173 473.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.303 445.236C446.586 445.236 451.68 444.076 451.68 442.646C451.68 441.216 446.586 440.057 440.303 440.057C434.019 440.057 428.925 441.216 428.925 442.646C428.925 444.076 434.019 445.236 440.303 445.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.524 371.914C565.524 371.914 565.288 372.518 564.898 373.514C563.541 376.647 560.453 383.9 556.649 390.77C556.524 391.028 556.355 391.257 556.228 391.522C555.941 392.09 555.609 392.629 555.277 393.166C555.115 393.476 554.872 393.793 554.717 394.102L529.795 391.057L525.453 390.571L523.168 390.283L521.34 390.047L502.692 387.792L498.38 387.254L492.904 374.399C496.434 369.89 501.28 366.592 506.769 364.964L506.806 364.92C511.154 363.738 515.723 363.623 520.126 364.583C522.506 365.025 524.902 365.542 527.286 365.983C527.92 366.093 528.55 366.211 529.129 366.293C534.651 367.311 540.031 368.217 544.867 369.006C545.53 369.072 546.112 369.153 546.739 369.271C546.992 369.315 547.321 369.355 547.572 369.396C555.445 370.613 561.548 371.418 564.158 371.741C564.609 371.829 565.065 371.887 565.524 371.914Z",
    fill: "url(#paint5_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.528 371.914C565.528 371.914 565.292 372.518 564.901 373.514C562.889 374.862 558.511 377.642 552.459 380.952C549.385 382.566 546.009 384.313 542.213 386.031C541.431 386.343 540.665 386.697 539.921 387.092L539.876 387.063L539.839 387.106C536.561 388.591 533.211 389.909 529.8 391.057L525.458 390.571C530.113 389.088 534.683 387.351 539.147 385.367C539.958 385.05 540.724 384.693 541.49 384.342C545.281 382.618 548.735 380.863 551.768 379.212C556.036 376.957 560.173 374.462 564.159 371.738C564.611 371.828 565.068 371.886 565.528 371.914Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.319 393.162L539.842 387.068L539.831 387.083L538.718 386.636L539.169 385.363L544.898 368.984C545.514 369.081 546.133 369.177 546.734 369.263L541.468 384.328L541.04 385.572L542.194 386.027L556.224 391.536C555.927 392.076 555.621 392.606 555.319 393.162Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.29 365.977L521.349 390.048L523.174 390.28L529.127 366.289C528.544 366.205 527.916 366.092 527.29 365.977Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.711 376.197C530.789 377.059 530.781 377.927 530.688 378.788C530.66 379.045 530.632 379.304 530.584 379.567C530.467 380.346 530.291 381.115 530.056 381.868C529.885 382.475 529.671 383.07 529.415 383.647C529.392 383.734 529.361 383.818 529.322 383.899C529.232 384.208 529.115 384.507 528.971 384.795C528.972 384.798 528.972 384.8 528.971 384.803C528.971 384.806 528.97 384.808 528.969 384.811C528.967 384.813 528.965 384.815 528.963 384.817C528.96 384.818 528.958 384.819 528.955 384.819C528.943 384.864 528.908 384.893 528.897 384.937C528.481 385.343 527.855 385.942 527.182 386.615C526.956 386.832 526.731 387.049 526.484 387.272C526.35 387.427 526.192 387.566 526.056 387.721C525.133 388.563 524.271 389.468 523.473 390.429C522.813 390.684 522.13 390.875 521.434 390.999L520.086 391.292C519.785 391.358 519.464 391.428 519.119 391.482C518.657 391.583 518.155 391.692 517.65 391.781L517.55 391.803C517.288 391.859 517.028 391.917 516.763 391.953C516.342 392.045 515.896 392.121 515.474 392.213C513.521 392.638 511.542 392.929 509.549 393.084C509.415 393.051 509.157 392.728 508.791 392.22C508.379 391.679 507.874 390.907 507.299 390.002C507.136 389.743 506.951 389.469 506.785 389.19C506.776 388.853 506.762 388.502 506.746 388.148C506.744 386.493 506.897 384.841 507.205 383.215C507.318 382.58 507.421 381.991 507.484 381.409C507.507 381.296 507.517 381.181 507.515 381.066C507.738 379.248 507.649 377.406 507.252 375.618C506.763 373.685 506.019 371.825 505.037 370.09C504.279 368.553 503.254 366.823 502.107 364.844C497.503 357.022 502.389 359.004 505.003 350.176C505.396 348.807 505.422 347.359 505.077 345.978C503.517 339.215 494.974 333.281 501.156 327.899C501.375 327.694 501.607 327.503 501.85 327.327C501.901 327.268 501.962 327.22 502.03 327.183C502.32 326.959 502.628 326.759 502.95 326.583C511.499 321.651 517.121 335.387 517.47 336.215L517.478 336.256L520.776 339.718C520.776 339.718 524.125 364.332 528.91 370.854L528.914 370.875C530.011 372.44 530.635 374.287 530.711 376.197Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.573 349.122C511.63 348.716 511.667 348.314 511.723 347.909C512.614 347.272 513.417 346.523 514.114 345.679C514.967 344.671 515.702 343.569 516.304 342.394C515.263 343.215 514.327 344.105 513.348 344.931C512.872 345.352 512.388 345.773 511.9 346.169C512.087 344.355 512.018 342.524 511.696 340.729C511.46 339.694 511.128 338.685 510.702 337.713C511.156 336.783 511.482 335.796 511.672 334.779C511.892 333.78 511.949 332.752 511.84 331.734C511.377 333.293 510.778 334.807 510.049 336.26C508.133 332.73 505.748 329.475 502.959 326.584C502.637 326.76 502.329 326.96 502.039 327.183C501.971 327.221 501.91 327.27 501.859 327.328C504.648 330.193 507.022 333.433 508.914 336.955C507.893 337.044 506.865 337.015 505.851 336.87C505.16 336.774 504.487 336.583 503.849 336.301C503.526 336.151 503.213 335.98 502.913 335.79C502.589 335.612 502.345 335.342 502.025 335.121C502.389 335.819 502.896 336.434 503.513 336.923C504.13 337.413 504.843 337.767 505.607 337.962C506.877 338.298 508.203 338.369 509.502 338.17C509.906 339.082 510.219 340.032 510.435 341.006C510.781 343.029 510.805 345.095 510.508 347.126V347.134C509.57 347.17 508.631 347.146 507.696 347.063C506.729 346.909 505.685 346.752 505.061 345.85C505.102 346.127 505.207 346.391 505.369 346.62C505.539 346.853 505.742 347.059 505.971 347.233C506.436 347.559 506.951 347.807 507.495 347.967C508.423 348.262 509.391 348.409 510.365 348.403C510.327 348.588 510.299 348.775 510.28 348.963C509.79 352.978 509.262 357.108 512.202 359.703L512.209 359.711C511.12 359.922 510.015 360.041 508.906 360.066C507.323 360.201 505.742 359.775 504.442 358.862C504.9 359.595 505.565 360.176 506.353 360.533C507.148 360.885 507.995 361.106 508.861 361.186C510.451 361.313 512.051 361.152 513.584 360.71C514.622 361.544 515.325 362.724 515.566 364.034C516.011 365.87 516.245 367.751 516.262 369.64C516.293 370.264 516.288 370.917 516.268 371.593C516.273 372.391 516.264 373.212 516.209 374.023C516.15 375.296 516.048 376.559 515.941 377.801C515.871 378.446 515.797 379.071 515.724 379.697V379.717C515.614 380.751 515.471 381.747 515.345 382.7C515.07 384.526 514.792 386.141 514.556 387.369L515.849 387.612C515.893 387.33 516.008 386.801 516.144 386.077C516.334 384.922 516.603 383.266 516.872 381.316C516.921 380.865 516.989 380.408 517.053 379.931C517.127 379.306 517.197 378.661 517.266 378.015C517.461 376.018 517.603 373.887 517.635 371.799C517.635 371.125 517.635 370.451 517.62 369.805C517.603 369.242 517.585 368.678 517.551 368.139C517.469 366.981 517.309 365.829 517.073 364.692C516.806 362.925 516.009 361.282 514.786 359.98C515.4 359.382 515.928 358.701 516.354 357.958C516.942 357.018 517.415 356.012 517.763 354.96L515.67 357.452C515.101 358.114 514.467 358.716 513.777 359.251C513.772 359.246 513.766 359.242 513.761 359.237C513.722 359.246 513.717 359.226 513.693 359.21C510.645 357.189 510.997 353.599 511.543 349.445C511.543 349.337 511.553 349.228 511.573 349.122Z",
    fill: "url(#paint6_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.859 355.37C529.859 355.37 518.752 333.259 542.347 319.756C542.347 319.756 549.999 333.394 540.552 345.281L537.217 343.259L538.459 347.134L529.859 355.37Z",
    fill: "url(#paint7_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.466 396.251C528.466 396.251 528.321 392.376 528.434 386.468C528.557 380.579 528.974 372.717 529.944 364.907C530.417 361 531.078 357.122 531.784 353.498C532.548 349.887 533.428 346.557 534.292 343.726C535.015 341.455 535.861 339.225 536.825 337.045L537.937 334.562C537.937 334.562 537.47 335.434 536.656 336.962C535.535 339.085 534.531 341.267 533.646 343.498C532.581 346.283 531.455 349.579 530.434 353.172C529.469 356.775 528.528 360.649 527.778 364.562C526.251 372.383 525.278 380.304 524.739 386.264C524.208 392.21 524.077 396.251 524.077 396.251H528.466Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.16 329.213C534.006 331.979 535.07 334.673 536.34 337.271L536.559 337.746L537.031 337.538C539.347 336.576 541.591 335.45 543.746 334.168C541.317 334.793 538.936 335.589 536.62 336.552L537.309 336.819C536.129 334.178 534.742 331.635 533.16 329.213Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.217 337.586C530.075 340.209 531.257 342.715 532.735 345.046L532.926 345.357L533.23 345.286C534.427 345.008 535.603 344.647 536.749 344.204C535.521 344.168 534.291 344.219 533.07 344.356L533.564 344.595C532.412 342.087 530.952 339.733 529.217 337.586Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.231 364.5C542.231 364.5 544.181 346.65 563.881 347.726C563.881 347.726 563.166 359.052 552.724 362.571L551.49 360.023L550.717 362.874L542.231 364.5Z",
    fill: "url(#paint8_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.267 388.854C525.267 388.854 526.707 386.435 529.105 382.882C531.502 379.344 534.855 374.717 538.524 370.342C540.352 368.152 542.284 366.046 544.142 364.118C546.032 362.219 547.881 360.538 549.523 359.153C550.859 358.055 552.254 357.03 553.7 356.081L555.357 355.007L553.629 355.965C552.11 356.816 550.639 357.749 549.22 358.759C547.473 360.035 545.491 361.602 543.451 363.387C541.442 365.2 539.342 367.19 537.343 369.278C533.33 373.44 529.614 377.882 526.936 381.301C524.258 384.719 522.597 387.123 522.597 387.123L525.267 388.854Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.554 349.866C553.98 351.884 553.566 353.944 553.316 356.028L553.261 356.403L553.63 356.463C555.42 356.789 557.231 356.987 559.05 357.057C557.324 356.48 555.559 356.026 553.769 355.699L554.084 356.133C554.406 354.06 554.564 351.964 554.554 349.866Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.852 353.412C548.341 355.348 548.073 357.34 548.054 359.343L548.048 359.608L548.262 359.684C549.101 359.987 549.96 360.23 550.833 360.413C550.098 359.907 549.329 359.453 548.531 359.055L548.737 359.392C549.024 357.411 549.062 355.402 548.852 353.412Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.009 335.445C201.009 335.445 190.364 314.254 212.977 301.315C212.977 301.315 220.31 314.385 211.257 325.779L208.061 323.841L209.251 327.558L201.009 335.445Z",
    fill: "url(#paint9_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.674 374.619C199.674 374.619 199.535 370.906 199.645 365.245C199.763 359.6 200.162 352.067 201.091 344.583C201.544 340.839 202.178 337.123 202.854 333.65C203.587 330.19 204.431 326.995 205.258 324.285C205.951 322.108 206.761 319.971 207.685 317.882L208.751 315.502L207.521 317.804C206.448 319.838 205.486 321.929 204.638 324.066C203.617 326.735 202.543 329.894 201.561 333.333C200.634 336.787 199.734 340.498 199.016 344.247C197.551 351.745 196.619 359.333 196.103 365.045C195.597 370.742 195.47 374.615 195.47 374.615L199.674 374.619Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.173 310.377C204.984 313.027 206.003 315.609 207.221 318.098L207.43 318.553L207.881 318.355C210.1 317.432 212.25 316.353 214.316 315.125C211.989 315.724 209.707 316.487 207.489 317.409L208.148 317.662C207.018 315.132 205.688 312.696 204.173 310.377Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.395 318.4C201.217 320.914 202.349 323.316 203.764 325.55L203.948 325.848L204.239 325.78C205.385 325.513 206.511 325.167 207.609 324.743C206.432 324.708 205.254 324.757 204.084 324.888L204.557 325.118C203.454 322.714 202.056 320.458 200.395 318.4Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.865 344.192C212.865 344.192 214.733 327.091 233.61 328.119C233.61 328.119 232.925 338.973 222.917 342.344L221.738 339.901L220.997 342.635L212.865 344.192Z",
    fill: "url(#paint10_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.609 367.531C196.609 367.531 197.989 365.213 200.287 361.808C202.583 358.418 205.797 353.985 209.312 349.792C211.064 347.686 212.915 345.676 214.696 343.827C216.507 342.008 218.279 340.397 219.853 339.07C221.133 338.018 222.469 337.035 223.855 336.125L225.443 335.097L223.788 336.014C222.332 336.831 220.922 337.725 219.562 338.692C217.887 339.916 215.988 341.417 214.033 343.128C212.108 344.866 210.096 346.772 208.179 348.772C204.333 352.761 200.773 357.018 198.207 360.294C195.641 363.569 194.048 365.875 194.048 365.875L196.609 367.531Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.674 330.168C224.123 332.102 223.726 334.077 223.487 336.074L223.435 336.433L223.788 336.491C225.504 336.803 227.239 336.994 228.982 337.06C227.328 336.507 225.637 336.072 223.921 335.76L224.223 336.176C224.532 334.188 224.683 332.18 224.674 330.168Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.21 333.566C218.72 335.421 218.463 337.331 218.446 339.25L218.44 339.502L218.644 339.576C219.447 339.866 220.271 340.099 221.107 340.274C220.403 339.789 219.666 339.354 218.902 338.973L219.1 339.299C219.375 337.4 219.412 335.474 219.21 333.566Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.229 396.249C278.229 396.249 278.049 366.421 289.271 360.972C300.494 355.522 301.217 360.972 301.217 360.972C301.217 360.972 298.683 354.798 306.286 351.178C313.889 347.559 314.069 355.196 314.069 355.196C314.069 355.196 320.405 346.36 327.283 347.14C334.16 347.92 335.684 355.396 335.684 355.396C335.684 355.396 339.229 345.746 346.107 345.383C352.986 345.021 349.904 351.266 349.904 351.266C349.904 351.266 355.581 342.487 359.894 343.937C364.207 345.387 363.419 355.195 363.419 355.195C363.419 355.195 373.258 350.204 375.43 355.397C376.749 358.665 377.369 362.174 377.249 365.696C377.249 365.696 382.311 355.562 385.931 360.973C389.551 366.384 387.379 369.229 387.379 369.229C387.379 369.229 393.171 364.576 396.792 372.177C400.413 379.778 398.239 396.251 398.239 396.251L278.229 396.249Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.98 381.847C269.98 381.847 281.561 362.864 298.442 373.345C298.442 373.345 309.49 360.595 318.697 361.622C327.905 362.649 325.437 367.74 325.437 367.74C325.437 367.74 334.04 362.988 337.723 366.348C338.75 367.161 339.442 368.323 339.668 369.613C339.894 370.903 339.639 372.231 338.951 373.345C338.951 373.345 341.1 362.527 353.99 361.513C366.879 360.5 361.073 372.128 361.073 372.128C361.073 372.128 364.344 365.473 369.755 367.436C375.167 369.4 371.177 373.342 371.177 373.342C371.177 373.342 380.233 370.933 382.61 378.298C384.987 385.664 378.845 385.357 378.845 385.357C378.845 385.357 386.522 389.96 380.844 396.252H273.605L269.98 381.847Z",
    fill: "url(#paint11_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.673 396.25C514.673 396.25 514.826 370.962 505.312 366.344C495.798 361.727 495.184 366.344 495.184 366.344C495.184 366.344 497.333 361.11 490.888 358.041C484.443 354.973 484.289 361.447 484.289 361.447C484.289 361.447 478.918 353.957 473.085 354.618C467.252 355.279 465.963 361.618 465.963 361.618C465.963 361.618 462.957 353.438 457.126 353.13C451.294 352.823 453.908 358.118 453.908 358.118C453.908 358.118 449.094 350.675 445.437 351.903C441.78 353.13 442.45 361.447 442.45 361.447C442.45 361.447 434.11 357.216 432.267 361.616C431.149 364.386 430.624 367.36 430.726 370.346C430.726 370.346 426.436 361.753 423.366 366.342C420.296 370.93 422.138 373.339 422.138 373.339C422.138 373.339 417.228 369.395 414.158 375.84C411.089 382.285 412.931 396.249 412.931 396.249L514.673 396.25Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.125 388.117C508.125 388.117 513.493 379.783 521.972 383.298C521.972 383.298 528.381 376.914 533.214 380.137C538.048 383.36 535.286 386.118 535.286 386.118C535.286 386.118 539.199 379.007 543.573 379.225C547.946 379.443 548.023 383.295 548.023 383.295C548.023 383.295 550.639 376.925 554.817 379.22C558.996 381.515 558.949 385.201 558.949 385.201C558.949 385.201 567.742 382.975 570.964 388.117C574.186 393.258 568.858 396.25 568.858 396.25H508.12L508.125 388.117Z",
    fill: "#369E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.317 396.25C420.317 396.25 417.862 370.077 435.049 367.434C452.237 364.792 453.683 377.375 453.683 377.375C453.683 377.375 458.063 368.228 464.513 370.347C470.962 372.465 470.958 377.375 470.958 377.375C470.958 377.375 474.334 360.897 482.621 361.617C490.907 362.336 491.521 367.434 491.521 367.434C491.521 367.434 496.431 364.518 499.194 366.339C501.956 368.161 501.036 373.336 501.036 373.336C501.036 373.336 505.946 375.248 506.253 378.918C506.362 379.909 506.099 380.905 505.516 381.713C504.933 382.522 504.071 383.085 503.096 383.295C503.096 383.295 512.084 376.484 515.153 381.839C518.222 387.193 515.92 390.415 515.92 390.415C515.92 390.415 518.375 389.341 518.375 396.247L420.317 396.25Z",
    fill: "url(#paint12_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.744 390.71C362.744 390.71 366.211 378.505 377.313 377.997C388.415 377.489 388.557 382.739 388.557 382.739C388.557 382.739 395.801 376.367 399.496 377.997C403.191 379.628 402.413 381.739 402.413 381.739C402.413 381.739 406.89 370.397 413.982 370.348C421.075 370.298 420.881 375.739 420.881 375.739C420.881 375.739 424.381 373.601 426.519 376.322C428.657 379.043 426.519 380.968 426.519 380.968C426.519 380.968 433.129 379.938 432.157 385.226C431.184 390.514 428.463 389.347 428.463 389.347C429.388 390.224 430.098 391.304 430.537 392.502C430.975 393.699 431.13 394.982 430.99 396.249H361.781L362.744 390.71Z",
    fill: "url(#paint13_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.104 390.71C484.104 390.71 487.571 378.505 498.673 377.997C509.774 377.489 509.916 382.739 509.916 382.739C509.916 382.739 517.161 376.367 520.856 377.997C524.551 379.628 523.772 381.739 523.772 381.739C523.772 381.739 528.25 370.397 535.343 370.348C542.436 370.298 542.241 375.739 542.241 375.739C542.241 375.739 545.741 373.601 547.879 376.322C550.017 379.043 547.879 380.968 547.879 380.968C547.879 380.968 554.489 379.938 553.516 385.226C552.544 390.514 549.822 389.347 549.822 389.347C550.748 390.224 551.458 391.304 551.896 392.502C552.335 393.699 552.49 394.982 552.35 396.249H483.141L484.104 390.71Z",
    fill: "url(#paint14_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.95 372.419C178.373 370.916 178.225 369.283 178.523 367.7C178.82 366.118 179.552 364.65 180.635 363.459C181.718 362.269 183.111 361.402 184.658 360.957C186.205 360.511 187.845 360.505 189.396 360.937C188.313 358.395 188.524 355.169 190.897 352.077C196.036 348.193 201.54 350.21 203.627 354.273C203.633 352.928 204.114 351.628 204.986 350.603C205.857 349.578 207.063 348.893 208.39 348.671C209.717 348.448 211.08 348.701 212.238 349.386C213.397 350.071 214.276 351.143 214.721 352.413C216.314 351.113 218.316 350.421 220.372 350.459C222.427 350.497 224.402 351.263 225.947 352.62C226.883 351.179 228.169 350 229.685 349.193C231.202 348.385 232.898 347.977 234.616 348.004C236.334 348.032 238.016 348.495 239.506 349.351C240.995 350.207 242.243 351.427 243.132 352.897C244.965 351.273 247.182 350.143 249.573 349.616C251.964 349.089 254.451 349.181 256.797 349.884C259.142 350.588 261.27 351.878 262.977 353.634C264.684 355.39 265.914 357.552 266.551 359.917C267.137 359.86 267.73 359.833 268.329 359.833C284.223 359.833 295.361 380.193 277.083 396.254H173.222V380.596C173.222 378.81 173.772 377.068 174.797 375.605C175.822 374.142 177.272 373.03 178.95 372.419Z",
    fill: "url(#paint15_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.546 76.616C191.922 77.4028 188.434 56.1638 198.267 53.4108C208.099 50.6578 208.099 62.4567 215.179 62.8501C222.259 63.2435 221.865 56.9532 231.698 56.3972C241.531 55.8412 239.171 67.9627 249.004 69.2314C258.836 70.5001 263.016 76.616 263.016 76.616H168.546Z",
    fill: "url(#paint16_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.345 206.339H230.752C230.752 206.339 228.399 193.634 212.401 195.046C196.402 196.457 206.283 187.517 194.049 182.341C181.814 177.165 187.461 196.457 176.638 196.457C165.816 196.457 171.932 207.28 157.345 206.339Z",
    fill: "url(#paint17_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.524 88.3772H500.318C500.318 88.3772 496.864 69.7211 473.369 71.7934C449.874 73.8657 464.387 60.7375 446.421 53.1373C428.456 45.537 436.747 73.8666 420.855 73.8666C404.963 73.8666 413.944 89.7554 392.524 88.3772Z",
    fill: "url(#paint18_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.042 38.6962H327.044C327.044 38.6962 325.89 32.4623 318.043 33.1573C310.196 33.8523 315.043 29.465 309.043 26.9234C303.042 24.3819 305.812 33.8472 300.504 33.8472C295.196 33.8472 298.197 39.1578 291.042 38.6962Z",
    fill: "url(#paint19_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.625 127.024C544.355 127.606 546.93 111.913 539.665 109.879C532.4 107.844 532.4 116.562 527.169 116.852C521.939 117.142 522.229 112.494 514.963 112.085C507.698 111.676 509.442 120.63 502.177 121.567C494.912 122.504 491.825 127.024 491.825 127.024L561.625 127.024Z",
    fill: "url(#paint20_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.559 221.406L480.083 280.56H466.963L464.14 226.05L456.275 213.026V253.546H392.864L393.615 243.985L348.283 257.991L345.828 247.177L379.979 226.052L388.198 175.162C388.785 171.51 390.274 168.063 392.528 165.131C394.783 162.199 397.733 159.876 401.112 158.371L411.811 153.594L429.93 150.128L456.298 159.268C458.839 160.148 461.163 161.56 463.115 163.41C465.067 165.259 466.603 167.503 467.62 169.993L483.785 209.502C485.322 213.27 485.931 217.353 485.559 221.406Z",
    fill: "url(#paint21_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.838 243.616L322.856 245.582L324.322 255.655C324.322 255.655 323.961 260.386 331.146 261.307C338.331 262.229 348.284 257.991 348.284 257.991L345.828 247.179C338.52 240.207 330.838 243.616 330.838 243.616Z",
    fill: "url(#paint22_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.953 143C434.353 143 445.216 132.137 445.216 118.737C445.216 105.337 434.353 94.4736 420.953 94.4736C407.553 94.4736 396.69 105.337 396.69 118.737C396.69 132.137 407.553 143 420.953 143Z",
    fill: "url(#paint23_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.928 150.126V133.172C429.928 133.172 435.672 130.745 434.29 125.77C432.907 120.795 426.273 122.913 426.181 128.627C426.181 128.627 422.404 124.849 424.983 118.307C424.983 118.307 413.927 123.651 403.515 118.307C403.515 118.307 403.423 140.605 404.621 144.475C405.819 148.345 411.808 147.332 411.808 147.332V153.598L417.337 162.075L429.928 150.126Z",
    fill: "url(#paint24_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.808 147.331C411.808 147.331 420.653 146.133 423.971 142.632C423.971 142.632 420.011 150.555 411.809 150.555L411.808 147.331Z",
    fill: "url(#paint25_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.962 280.56C466.027 282.908 465.528 285.405 465.487 287.931C465.487 291.897 462.355 293.46 464.013 293.651C465.672 293.828 468.068 290.054 468.068 290.054L470.869 303.315C471.054 304.157 471.533 304.906 472.221 305.426C472.909 305.946 473.759 306.204 474.62 306.154C475.481 306.103 476.295 305.747 476.917 305.149C477.539 304.551 477.927 303.752 478.012 302.894L480.081 280.559L466.962 280.56Z",
    fill: "url(#paint26_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11 435.164H378.654L377.297 452.501H399.741L402.11 435.164Z",
    fill: "url(#paint27_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.274 435.164H432.637L434.765 452.501H456.274V435.164Z",
    fill: "url(#paint28_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.655 435.162H402.11L418.187 317.452L432.642 435.162H456.273V253.545H392.87L378.655 435.162Z",
    fill: "url(#paint29_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.619 243.985L397.815 190.356C397.815 190.356 393.987 217.449 389.748 225.738C385.51 234.027 387.906 235.505 389.748 237.347C391.591 239.19 387.406 241.574 386.616 243.981C386.036 245.212 385.114 246.248 383.959 246.966L393.619 243.985Z",
    fill: "#EAAD03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.446 220.643C446.937 232.929 444.311 239.317 439.85 238.089C435.39 236.861 431.457 232.664 430.229 239.677C429.001 246.69 429.259 249.146 423.97 248.408C420.503 247.925 419.519 251.137 416.277 253.547H456.273V213.027L439.846 185.828C439.846 185.828 445.954 208.358 446.446 220.643Z",
    fill: "#EAAD03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.398 352.51L418.187 317.453L413.398 278.464V352.51Z",
    fill: "#1D164D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.589,
    y: 214.816,
    width: 40.9911,
    height: 29.4845,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.361 233.547C334.166 233.547 333.978 233.469 333.84 233.331C333.702 233.193 333.624 233.005 333.624 232.81V221.996C333.624 221.801 333.702 221.613 333.84 221.475C333.978 221.337 334.166 221.259 334.361 221.259C334.557 221.259 334.744 221.337 334.883 221.475C335.021 221.613 335.098 221.801 335.098 221.996V232.81C335.098 233.005 335.021 233.193 334.883 233.331C334.744 233.469 334.557 233.547 334.361 233.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.416 237.365C328.32 237.366 328.224 237.347 328.134 237.31C328.045 237.273 327.963 237.218 327.895 237.15L320.7 229.956C320.628 229.888 320.571 229.806 320.532 229.716C320.492 229.626 320.471 229.529 320.47 229.43C320.469 229.332 320.487 229.234 320.524 229.143C320.561 229.052 320.616 228.969 320.686 228.899C320.755 228.83 320.838 228.775 320.93 228.738C321.021 228.701 321.118 228.682 321.217 228.684C321.315 228.685 321.412 228.706 321.503 228.745C321.593 228.785 321.674 228.842 321.742 228.914L328.937 236.108C329.04 236.211 329.11 236.342 329.139 236.485C329.167 236.628 329.153 236.777 329.097 236.911C329.041 237.046 328.947 237.161 328.825 237.242C328.704 237.323 328.561 237.366 328.416 237.366L328.416 237.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.355 237.366C340.209 237.366 340.067 237.322 339.945 237.242C339.824 237.161 339.729 237.045 339.674 236.911C339.618 236.776 339.603 236.628 339.632 236.485C339.66 236.341 339.73 236.21 339.834 236.107L347.028 228.913C347.096 228.841 347.177 228.784 347.267 228.745C347.357 228.705 347.455 228.684 347.553 228.683C347.651 228.682 347.749 228.7 347.84 228.737C347.931 228.774 348.014 228.829 348.084 228.899C348.154 228.968 348.209 229.051 348.246 229.142C348.283 229.234 348.301 229.331 348.3 229.43C348.299 229.528 348.278 229.625 348.238 229.716C348.199 229.806 348.141 229.887 348.07 229.955L340.876 237.149C340.807 237.218 340.726 237.272 340.637 237.309C340.548 237.346 340.452 237.366 340.355 237.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.074 442.745C402.417 442.745 403.717 443.215 404.749 444.074C405.781 444.933 406.479 446.127 406.722 447.448L409.418 462.082C409.572 462.919 409.54 463.779 409.324 464.602C409.109 465.425 408.715 466.19 408.171 466.844C407.626 467.498 406.945 468.024 406.174 468.385C405.404 468.746 404.564 468.933 403.713 468.933H346.356C345.751 468.933 345.17 468.692 344.742 468.264C344.313 467.836 344.073 467.255 344.073 466.649C344.073 465.779 344.323 464.927 344.794 464.195C345.265 463.463 345.937 462.882 346.729 462.521L377.611 448.503C377.611 448.503 395.665 458.359 401.074 442.745Z",
    fill: "url(#paint30_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.361 455.381C370.023 454.738 367.116 453.939 364.785 454.468C363.909 454.668 363.65 454.907 363.625 454.981C363.53 455.256 364.292 456.196 364.699 456.7C365.546 457.746 366.507 458.932 366.3 460.183C366.225 460.544 366.071 460.883 365.85 461.178C365.629 461.473 365.346 461.716 365.021 461.89C364.378 462.318 363.626 462.552 362.854 462.564C361.291 462.564 359.891 461.553 358.521 460.576C357.518 459.778 356.402 459.135 355.209 458.667L357.063 457.825C357.877 458.278 358.659 458.785 359.406 459.341C361.436 460.799 362.658 461.575 364.208 460.605C364.346 460.539 364.469 460.446 364.569 460.331C364.669 460.217 364.745 460.082 364.791 459.937C364.888 459.362 364.125 458.421 363.512 457.662C362.924 457.037 362.466 456.301 362.164 455.497L367.919 452.878C369.558 453.097 371.177 453.445 372.761 453.917C373.734 454.241 374.74 454.451 375.761 454.543C375.731 454.36 375.679 454.181 375.606 454.01C374.973 452.409 373.199 451.64 371.446 451.272L373.544 450.317C374.311 450.566 375.016 450.974 375.615 451.514C376.214 452.054 376.693 452.714 377.02 453.45C377.16 453.802 377.583 454.87 376.947 455.578C376.184 456.429 374.663 456.016 372.361 455.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.273 442.748C457.616 442.747 458.916 443.218 459.948 444.077C460.98 444.936 461.678 446.13 461.922 447.451L464.617 462.085C464.771 462.922 464.739 463.782 464.524 464.605C464.308 465.428 463.914 466.193 463.37 466.847C462.825 467.501 462.144 468.027 461.374 468.388C460.603 468.749 459.763 468.936 458.912 468.936H401.556C400.95 468.936 400.369 468.695 399.941 468.267C399.512 467.839 399.271 467.258 399.271 466.652C399.271 465.782 399.522 464.93 399.993 464.198C400.464 463.466 401.135 462.885 401.927 462.524L434.209 447.969C434.209 447.969 450.865 458.362 456.273 442.748Z",
    fill: "url(#paint31_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.561 455.384C425.223 454.74 422.316 453.943 419.984 454.472C419.108 454.671 418.85 454.911 418.825 454.984C418.73 455.259 419.492 456.199 419.899 456.702C420.746 457.748 421.706 458.935 421.499 460.184C421.424 460.545 421.271 460.885 421.05 461.179C420.829 461.474 420.546 461.717 420.221 461.891C419.579 462.319 418.826 462.553 418.054 462.565C416.49 462.565 415.09 461.559 413.721 460.577C412.718 459.779 411.602 459.136 410.409 458.669L412.266 457.826C413.08 458.279 413.863 458.786 414.61 459.343C416.639 460.8 417.862 461.576 419.412 460.606C419.549 460.541 419.672 460.448 419.772 460.333C419.872 460.218 419.948 460.084 419.994 459.938C420.091 459.364 419.328 458.422 418.716 457.664C418.128 457.038 417.669 456.302 417.368 455.499L423.122 452.879C424.761 453.098 426.38 453.446 427.964 453.918C428.936 454.242 429.943 454.452 430.964 454.544C430.934 454.361 430.882 454.182 430.809 454.011C430.177 452.41 428.403 451.641 426.65 451.273L428.747 450.319C429.514 450.568 430.22 450.976 430.819 451.516C431.418 452.056 431.896 452.716 432.224 453.452C432.364 453.803 432.787 454.872 432.15 455.579C431.384 456.432 429.863 456.018 427.561 455.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.663 188.417C499.188 188.417 510.152 177.453 510.152 163.929C510.152 150.404 499.188 139.441 485.663 139.441C472.139 139.441 461.175 150.404 461.175 163.929C461.175 177.453 472.139 188.417 485.663 188.417Z",
    fill: "url(#paint32_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M507.919 174.141C509.781 170.093 510.499 165.613 509.994 161.187C507.192 163.282 503.699 164.234 500.222 163.85C496.745 163.465 493.544 161.774 491.267 159.118C488.99 156.462 487.808 153.04 487.959 149.545C488.111 146.05 489.586 142.743 492.084 140.295C487.789 139.128 483.257 139.154 478.975 140.37C477.158 144.625 476.566 149.304 477.269 153.878C477.972 158.451 479.94 162.737 482.951 166.25C485.963 169.763 489.897 172.364 494.309 173.758C498.722 175.152 503.436 175.284 507.919 174.138V174.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.394 174.612V177.955H484.41V174.7C481.758 174.617 479.183 173.79 476.979 172.313L478.621 168.672C480.334 169.868 482.329 170.598 484.41 170.792V165.808C481.097 165.003 477.397 163.898 477.397 159.631C477.397 156.467 479.695 153.752 484.41 153.215V149.903H487.394V153.156C489.529 153.273 491.605 153.897 493.452 154.975L491.96 158.646C490.557 157.83 489.004 157.302 487.394 157.094V162.167C490.706 162.943 494.347 164.046 494.347 168.254C494.347 171.36 492.078 174.045 487.394 174.612ZM484.41 161.422V157.185C482.828 157.543 482.202 158.409 482.202 159.394C482.201 160.438 483.097 161.004 484.41 161.422ZM489.543 168.614C489.543 167.569 488.678 167.002 487.394 166.555V170.674C488.886 170.345 489.538 169.569 489.538 168.614H489.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.188 437.971L301.001 452.587H278.761L278.894 437.971H302.188Z",
    fill: "url(#paint33_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85 442.748C277.508 442.748 276.207 443.218 275.175 444.077C274.144 444.937 273.445 446.13 273.202 447.451L270.506 462.085C270.352 462.922 270.384 463.782 270.6 464.605C270.816 465.428 271.209 466.193 271.754 466.847C272.298 467.501 272.98 468.027 273.75 468.388C274.52 468.749 275.36 468.936 276.211 468.936H333.569C334.174 468.936 334.755 468.695 335.184 468.267C335.612 467.839 335.852 467.258 335.852 466.652C335.852 465.782 335.602 464.93 335.131 464.198C334.66 463.466 333.988 462.885 333.196 462.524L301.366 448.076C301.366 448.076 284.259 458.362 278.85 442.748Z",
    fill: "url(#paint34_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.563 455.384C309.901 454.74 312.808 453.943 315.14 454.472C316.015 454.671 316.275 454.911 316.299 454.984C316.394 455.259 315.634 456.199 315.226 456.702C314.379 457.748 313.418 458.935 313.625 460.184C313.701 460.545 313.854 460.885 314.075 461.179C314.296 461.474 314.578 461.717 314.903 461.891C315.546 462.319 316.298 462.553 317.07 462.565C318.634 462.565 320.034 461.559 321.404 460.577C322.407 459.779 323.523 459.136 324.716 458.669L322.858 457.826C322.044 458.279 321.262 458.786 320.515 459.343C318.485 460.8 317.263 461.576 315.713 460.606C315.575 460.541 315.452 460.448 315.352 460.333C315.252 460.218 315.177 460.084 315.131 459.938C315.034 459.364 315.796 458.422 316.409 457.664C316.997 457.038 317.455 456.302 317.757 455.499L312.002 452.879C310.364 453.098 308.745 453.446 307.161 453.918C306.188 454.242 305.181 454.452 304.16 454.544C304.19 454.361 304.242 454.182 304.315 454.011C304.948 452.41 306.722 451.641 308.475 451.273L306.377 450.319C305.61 450.568 304.905 450.976 304.306 451.516C303.707 452.056 303.228 452.716 302.901 453.452C302.761 453.803 302.339 454.872 302.975 455.579C303.741 456.432 305.26 456.018 307.563 455.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.101 227.768L315.131 241.405L307.834 253.545C297.838 250.044 288.101 246.196 288.101 246.196L289.782 254.363H224.953V171.747C224.953 168.864 225.785 166.041 227.348 163.619C228.912 161.196 231.141 159.276 233.769 158.088L251.375 150.127L269.494 153.599L273.179 154.815C278.213 156.477 282.604 159.667 285.74 163.941L300.819 184.463L332.202 143L343.016 150.127L314.26 211.021C313.428 212.777 311.936 214.134 310.108 214.795C308.28 215.457 306.265 215.369 304.501 214.551L288.1 206.944L288.101 227.768Z",
    fill: "url(#paint35_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.105 139.561C250.449 135.851 248.069 132.51 245.103 129.733C240.435 125.555 239.451 112.902 250.632 111.182C250.632 111.182 253.183 101.355 262.288 102.215C271.393 103.075 280.731 101.232 286.259 100.003C290.847 98.9831 290.381 105.17 289.876 107.932C288.33 116.412 281.854 121.175 274.956 125.433L252.105 139.561Z",
    fill: "url(#paint36_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.368 150.126V133.172C251.368 133.172 245.625 130.745 247.007 125.77C248.389 120.795 255.023 122.913 255.115 128.627C255.115 128.627 258.893 124.849 256.313 118.307C256.313 118.307 267.37 123.651 277.781 118.307C277.781 118.307 277.873 140.605 276.676 144.475C275.479 148.345 269.489 147.332 269.489 147.332V153.598L263.962 162.075L251.368 150.126Z",
    fill: "url(#paint37_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.49 147.331C269.49 147.331 260.644 146.133 257.328 142.632C257.328 142.632 261.287 150.555 269.49 150.555L269.49 147.331Z",
    fill: "url(#paint38_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.888 355.701L302.187 437.971H278.894L279.624 359.71L261.933 312.535L248.732 437.971H224.953V254.363H289.782L308.18 343.967C308.971 347.825 309.21 351.776 308.888 355.701Z",
    fill: "url(#paint39_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.776 276.027L261.933 312.536L274.696 346.57L265.776 276.027Z",
    fill: "#1D164D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.101 227.769L315.131 241.406L307.834 253.546C297.838 250.045 288.101 246.197 288.101 246.197L245.297 229.737C241.994 228.467 239.267 226.039 237.623 222.905L224.953 198.689V171.748C224.953 168.865 225.785 166.042 227.348 163.62C228.912 161.197 231.141 159.277 233.769 158.089L235.346 157.374C238.606 157.373 241.772 158.47 244.332 160.49C246.892 162.51 248.697 165.333 249.454 168.505L260.275 213.732L288.101 227.769Z",
    fill: "url(#paint40_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.549 140.295C366.11 135.872 342.036 124.572 342.036 124.572C342.036 124.572 339.514 123.282 338.962 128.132C338.155 135.215 335.151 133.048 332.202 143L343.016 150.127C343.016 150.127 358.989 144.717 362.549 140.295Z",
    fill: "url(#paint41_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.98 201.355C289.702 192.51 288.101 174.696 288.101 174.696V206.944L304.502 214.551C305.57 215.047 306.742 215.279 307.919 215.228C309.095 215.176 310.242 214.843 311.263 214.256C309.76 214.066 308.319 213.536 307.052 212.706C305.784 211.875 304.723 210.766 303.949 209.463C300.604 203.697 300.264 210.2 294.98 201.355Z",
    fill: "url(#paint42_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.676 210.077C271.885 206.207 269.858 210.814 265.067 205.456C260.349 200.186 250.096 170.774 249.779 169.86L260.276 213.733L288.1 227.768V222.366C274.172 216.863 280.876 213.47 276.676 210.077Z",
    fill: "url(#paint43_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.478 101.488H343.467C342.677 101.488 342.036 102.128 342.036 102.919V138.62C342.036 139.411 342.677 140.052 343.467 140.052H361.478C362.268 140.052 362.909 139.411 362.909 138.62V102.919C362.909 102.128 362.268 101.488 361.478 101.488Z",
    fill: "url(#paint44_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.698 137.84V103.699H344.247V137.84H360.698Z",
    fill: "url(#paint45_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.472 127.218C356.034 127.218 358.921 124.331 358.921 120.769C358.921 117.208 356.034 114.321 352.472 114.321C348.911 114.321 346.024 117.208 346.024 120.769C346.024 124.331 348.911 127.218 352.472 127.218Z",
    fill: "url(#paint46_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.147 123.887L348.614 121.354L349.656 120.312L351.147 121.802L355.297 117.652L356.339 118.694L351.147 123.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.953 437.971H248.732L247.192 452.587H224.952L224.953 437.971Z",
    fill: "url(#paint47_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.954 442.748C223.611 442.748 222.31 443.218 221.279 444.077C220.247 444.937 219.548 446.13 219.305 447.451L216.609 462.085C216.455 462.922 216.487 463.782 216.703 464.605C216.919 465.428 217.313 466.193 217.857 466.847C218.401 467.501 219.083 468.027 219.853 468.388C220.623 468.749 221.464 468.936 222.314 468.936H279.671C280.277 468.936 280.858 468.695 281.286 468.267C281.714 467.839 281.955 467.258 281.955 466.652C281.955 465.782 281.704 464.93 281.233 464.198C280.762 463.466 280.091 462.885 279.299 462.524L247.662 448.119C247.662 448.119 230.36 458.362 224.954 442.748Z",
    fill: "url(#paint48_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.664 455.384C256.001 454.74 258.91 453.943 261.24 454.472C262.115 454.671 262.375 454.911 262.399 454.984C262.495 455.259 261.733 456.199 261.326 456.702C260.478 457.748 259.518 458.935 259.725 460.184C259.8 460.545 259.954 460.885 260.175 461.18C260.396 461.475 260.679 461.717 261.004 461.891C261.646 462.319 262.398 462.553 263.17 462.565C264.734 462.565 266.134 461.559 267.504 460.577C268.507 459.779 269.623 459.136 270.816 458.669L268.958 457.826C268.144 458.279 267.361 458.786 266.614 459.343C264.584 460.8 263.363 461.576 261.813 460.606C261.675 460.541 261.552 460.448 261.452 460.333C261.351 460.218 261.276 460.084 261.23 459.938C261.133 459.364 261.896 458.422 262.508 457.664C263.096 457.038 263.554 456.302 263.856 455.499L258.101 452.879C256.462 453.098 254.844 453.446 253.26 453.918C252.287 454.242 251.281 454.452 250.26 454.544C250.289 454.361 250.341 454.182 250.414 454.011C251.048 452.41 252.821 451.641 254.574 451.273L252.477 450.319C251.71 450.568 251.004 450.976 250.405 451.516C249.806 452.056 249.327 452.715 249 453.452C248.861 453.803 248.438 454.872 249.074 455.579C249.842 456.432 251.361 456.018 253.664 455.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.113 255.151C338.851 255.452 338.567 255.734 338.265 255.994C338.256 256.007 338.243 256.018 338.228 256.023C338.184 256.068 338.132 256.112 338.088 256.149C338.086 256.149 338.084 256.15 338.083 256.151C338.081 256.152 338.081 256.154 338.081 256.156C335.73 258.11 331.889 259.518 327.171 259.097C323.549 258.773 315.613 256.267 307.837 253.547L315.134 241.407C315.134 241.407 315.201 241.385 315.303 241.348C317.931 240.602 320.674 240.342 323.396 240.581C328.924 240.854 331.04 238.915 332.049 240.021C333.058 241.127 330.73 243.618 330.73 243.618C330.73 243.618 329.071 246.139 326.86 246.81C324.648 247.48 325.754 249.206 329.44 249.147C333.126 249.088 336.664 249.795 338.226 251.077C339.493 252.13 340.023 253.818 339.113 255.151Z",
    fill: "url(#paint49_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.635 136.611C221.271 136.611 230.704 127.178 230.704 115.542C230.704 103.906 221.271 94.4736 209.635 94.4736C197.999 94.4736 188.566 103.906 188.566 115.542C188.566 127.178 197.999 136.611 209.635 136.611Z",
    fill: "url(#paint50_linear_1810_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.677 105.547C194.662 105.546 192.655 105.797 190.703 106.293C188.734 110.321 188.104 114.873 188.905 119.284C191.324 117.47 194.302 116.559 197.323 116.709C200.344 116.859 203.216 118.061 205.444 120.107C207.671 122.153 209.113 124.913 209.519 127.91C209.925 130.907 209.27 133.952 207.667 136.517C208.316 136.577 208.971 136.612 209.635 136.612C213.446 136.617 217.185 135.584 220.453 133.623C221.032 130.169 220.851 126.63 219.922 123.253C218.994 119.876 217.34 116.742 215.077 114.07C212.814 111.397 209.995 109.25 206.817 107.778C203.639 106.306 200.179 105.545 196.677 105.547Z",
    fill: "#C9E2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.635 109.55C207.072 106.987 202.914 104.202 200.35 106.77C199.74 107.38 199.256 108.103 198.926 108.9C198.596 109.697 198.426 110.55 198.426 111.413C198.426 112.275 198.596 113.129 198.926 113.925C199.256 114.722 199.74 115.446 200.35 116.055L209.635 125.34L218.92 116.055C220.151 114.824 220.843 113.154 220.843 111.413C220.843 109.671 220.151 108.001 218.92 106.77C216.357 104.202 212.199 106.987 209.635 109.55Z",
    fill: "url(#paint51_linear_1810_2336)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1810_2336",
    transform: "scale(0.0175439 0.0243902)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1810_2336",
    x1: 103.495,
    y1: 643.659,
    x2: 493.653,
    y2: 52.8699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1810_2336",
    x1: 0,
    y1: 149.184,
    x2: 114.026,
    y2: 149.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1810_2336",
    x1: 116.346,
    y1: 344.483,
    x2: 424.363,
    y2: 344.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626262",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1810_2336",
    x1: 153.452,
    y1: 384.153,
    x2: 506.734,
    y2: -197.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1810_2336",
    x1: 377.701,
    y1: 192.282,
    x2: 377.701,
    y2: 583.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#369E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#369E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1810_2336",
    x1: 492.904,
    y1: 379.021,
    x2: 565.524,
    y2: 379.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1810_2336",
    x1: 501.859,
    y1: 357.098,
    x2: 517.763,
    y2: 357.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1810_2336",
    x1: 521.947,
    y1: 348.853,
    x2: 550.813,
    y2: 342.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1810_2336",
    x1: 549.873,
    y1: 368.117,
    x2: 553.13,
    y2: 348.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1810_2336",
    x1: 193.427,
    y1: 329.199,
    x2: 221.089,
    y2: 323.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1810_2336",
    x1: 220.188,
    y1: 347.658,
    x2: 223.308,
    y2: 328.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1810_2336",
    x1: 300.538,
    y1: 420.926,
    x2: 303.959,
    y2: 374.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1810_2336",
    x1: 452.792,
    y1: 417.009,
    x2: 455.648,
    y2: 378.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1810_2336",
    x1: 397.018,
    y1: 407.232,
    x2: 397.018,
    y2: 381.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1810_2336",
    x1: 518.377,
    y1: 407.232,
    x2: 518.377,
    y2: 381.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1810_2336",
    x1: 229.881,
    y1: 399.15,
    x2: 229.881,
    y2: 353.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DF63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1810_2336",
    x1: 215.781,
    y1: 45.9494,
    x2: 215.781,
    y2: 87.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1810_2336",
    x1: 194.048,
    y1: 161.733,
    x2: 194.048,
    y2: 213.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1810_2336",
    x1: 446.421,
    y1: 22.8757,
    x2: 446.421,
    y2: 98.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1810_2336",
    x1: 309.043,
    y1: 16.8124,
    x2: 309.043,
    y2: 42.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1810_2336",
    x1: -820.346,
    y1: 104.366,
    x2: -820.346,
    y2: 134.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1810_2336",
    x1: 402.322,
    y1: 199.822,
    x2: 433.236,
    y2: 287.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1810_2336",
    x1: 356.548,
    y1: 252.913,
    x2: 332.644,
    y2: 251.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1810_2336",
    x1: 445.216,
    y1: 118.737,
    x2: 396.69,
    y2: 118.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1810_2336",
    x1: 442.531,
    y1: 169.296,
    x2: 412.098,
    y2: 146.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1810_2336",
    x1: 393.71,
    y1: 146.593,
    x2: 405.873,
    y2: 146.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1810_2336",
    x1: 471.805,
    y1: 258.388,
    x2: 471.805,
    y2: 294.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1810_2336",
    x1: 389.703,
    y1: 451.599,
    x2: 389.703,
    y2: 432.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1810_2336",
    x1: 444.455,
    y1: 454.547,
    x2: 444.455,
    y2: 435.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1810_2336",
    x1: 467.295,
    y1: 415.548,
    x2: 351.774,
    y2: 385.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1810_2336",
    x1: 399.305,
    y1: 455.839,
    x2: 347.279,
    y2: 455.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7283A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1810_2336",
    x1: 457.384,
    y1: 482.108,
    x2: 451.58,
    y2: 447.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7283A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1810_2336",
    x1: 508.878,
    y1: 135.327,
    x2: 469.109,
    y2: 184.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402864",
    stopOpacity: 0.93
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1810_2336",
    x1: 297.456,
    y1: 457.733,
    x2: 292.288,
    y2: 434.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1810_2336",
    x1: 270.411,
    y1: 455.842,
    x2: 335.852,
    y2: 455.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1810_2336",
    x1: 226.96,
    y1: 271.067,
    x2: 282.196,
    y2: 175.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D49F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1810_2336",
    x1: 241.799,
    y1: 119.726,
    x2: 290.185,
    y2: 119.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1810_2336",
    x1: 252.402,
    y1: 161.9,
    x2: 267.116,
    y2: 140.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1810_2336",
    x1: 257.328,
    y1: 146.593,
    x2: 269.49,
    y2: 146.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1810_2336",
    x1: 213.182,
    y1: 408.41,
    x2: 370.342,
    y2: 367.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1810_2336",
    x1: 310.441,
    y1: 305.19,
    x2: 239.403,
    y2: 173.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C45F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1810_2336",
    x1: 355.109,
    y1: 127.708,
    x2: 341.231,
    y2: 153.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1810_2336",
    x1: 280.874,
    y1: 209.073,
    x2: 311.53,
    y2: 201.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402864",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1810_2336",
    x1: 262.808,
    y1: 237.554,
    x2: 277.777,
    y2: 196.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402864",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1810_2336",
    x1: 347.567,
    y1: 151.814,
    x2: 363.619,
    y2: 122.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1810_2336",
    x1: 332.107,
    y1: 132.173,
    x2: 369.626,
    y2: 127.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1810_2336",
    x1: 356.355,
    y1: 127.721,
    x2: 349.571,
    y2: 115.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE42C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1810_2336",
    x1: 243.786,
    y1: 457.674,
    x2: 238.756,
    y2: 433.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1810_2336",
    x1: 216.514,
    y1: 455.842,
    x2: 281.955,
    y2: 455.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D164D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1810_2336",
    x1: 328.527,
    y1: 249.405,
    x2: 312.738,
    y2: 237.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1810_2336",
    x1: 215.829,
    y1: 102.901,
    x2: 199.059,
    y2: 137.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1810_2336",
    x1: 201.094,
    y1: 130.12,
    x2: 208.279,
    y2: 109.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D47F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_2336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 566.103,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1810_2336",
    width: 57,
    height: 41,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAApCAYAAACPzoEeAAAAAXNSR0IArs4c6QAABZFJREFUaAXl2dly3EYMRuE4+573f8zse+z+KJ4JRHOk2NL4wkEVBt3Y/0aTVJVevHz58oP3nT583wHC9/E7BPnipNY7uUa3BjmBWc/9EeBxf3Imb6e6JchAHWWdAjWZ/iZAbwVyAvPcTwYG/XPgTbl+nh3orUBqGFDg1MAf7bzERn+vX/zXzkA/O8CV8yYvnqYIIGAAfrqzPT1AAP6xGAXuKO+sT/y91STnFAH8fOdPlgzkn/t6iQ0kgDeZ5rsE+eUC8dli0zTF3xejpkrncJ6dbgGy60oCZHomCSQZSBJAE3VtZ1zXdqmfTrcAqSsN90wCaYIBVdPLBgH422KA+Yt7dvqvII/Fr5309AuoGhNoIF1PAO2PAMWe1Zj5l8uFznwvxsdAljRZ4GzirAA7bpoBBdaarfWcIv0ZpSdb56c+XX0ks1/9hJSopMkCJYqnzvosNrAAASn2CG7G1ejUNe3ZSz1MuVJfAFufgixxScl4C1o/knppxDWVfcqaIstT7mzTv3U2sgOZ8fyqT7r+ZHTp6dp1rUAnT2J6VFKJ41lgc1o/+duX87huT0bFAVUPesX29B10fzGJsdbHBeBaX53kTO5j3vNDjySS0NsRV0DyCWZtX6MAvGZYihlbD2r3FxMJaCD14PPTN1f9ergAPU6yBkiJ2CX2CagAm+kBJzm/4uijdO2Tl+Ipdpk/iU2s2j4/XywmgWZ30AD+uhjZqz/zbLWOIDlXJJCSSo4Vpa8AW9dYHOBsfI6kYADnevqJYyOr64+Ir3YGlB6ZYgA79G6VXqp1el0l4KQQbpoBtZdAwiPIpbqcphwoQKQDiKeeXzVJNdwe4L5e/M0uAylHV1Qf/Ou3ukt1R4xnpAEkoOIAdW0ldJLi5yT5ukLi+USactpdp9b0Ef9eKm6MCQL37c7AOuhqr+W9x+U1cBzQGcgAkpog0ykArLie0SPImiAVDmAvKrmsMbDs/Mojv4kB9d3OwALNNntZ220vR5ydbaMzkAwcCzo2xN6J19g8RWtXSY5AykHHP3D21hNkt2UCNEl7t0g+N0WMaxqXk17de0CPIDOSAgRLJLG/M00Pa0bDpMK42LXc9mIDKUfPkDgTlK+G+cmFH7qm4uQS66WDy9OB6SNey/PrSg+ghAID6EBijbqO7Z1yp0gixa2xHIDIJy4dvTpILs9cLxvTA1juYhzUL4t/2vnnJQGVJ5DVX6o7kvhITYTzPDmFYg1jTU2gHQwZkCRdh0OnKUwvrykC5HkETu5uCh8Agfpx8Q+7tJ+T5Hdvimu/NUieEWdBAdJIaxLx0VjNa6or3fTkAAYVLw5QTNfhiccOjg713JkgcN/v0jTpgOcTwLW8T2eT5KEJ1Inf7e5+a9SuZgGjt59Nr+2WQxNs5U2ydxPKSyJNA0CaFlABNM05RT56nTXW9o6ugWStEcGSoBqwZmfDTZNuFiy2q3lsommZXrn4AofUc0A9hyYJbACboJrH3Et1Rw+B5CEQBdIVjNgC0fPDpjA/MnDJmlmmDUDXPLs4UwMOUDXovFwCBzCf8pezXpfpPj0GknfBEyhdTK8R09Ac4Pa4RgLBVr5uRbbALJctzpTL1eeCBJ6vuo8CXD4PvnjYoxoL6NRrUlEHpjG+6eitxWn4CBJQNofR1bXv8PmzARY4ez64g17L61Sy6x7/WibQkmuiJrt6IuiaEBlActKMp7d3MHKhwACG54HVA78H6U1AShTQmrW3VtwkuoLpa5JPscml2mJJRM9/5hGHZ55yzTzL5Tq9eMt/pwMzucYCqWLNJDV1bKwc4meO8hSbLMcxj3pX6W1BlrAmayrJXkPHdbHJx3LM+DcCV4E3va7FJSuaTD/lQzZ+2ZMztvVDtnyuyqeClPhJDeydPUeOqyA9B+89/S9AvgKCCybdl0zGygAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.f4d18962bee2e4112fba1569ccd39c13.svg";
export { ForwardRef as ReactComponent };